export enum TransactionStatus {
  SUBMITTED = 'submitted',
  REPRICED = 'repriced',
  CANCELLED = 'cancelled',
  MINED = 'mined',
}
